import LogoJavaIcon from "../../../../src/icons/logo-java.svg";
import LogoJavaScriptIcon from "../../../../src/icons/logo-javascript.svg";
import LogoPHPIcon from "../../../../src/icons/logo-php.svg";
import LogoSwiftIcon from "../../../../src/icons/logo-swift.svg";
import LogoCSharpIcon from "../../../../src/icons/logo-csharp.svg";
import LogoPostmanIcon from "../../../../src/icons/logo-postman.svg";
import * as React from 'react';
export default {
  LogoJavaIcon,
  LogoJavaScriptIcon,
  LogoPHPIcon,
  LogoSwiftIcon,
  LogoCSharpIcon,
  LogoPostmanIcon,
  React
};